import React, { useEffect, useState } from 'react';
import { Box, SimpleGrid, Skeleton, SkeletonCircle, SkeletonText, FormControl } from '@chakra-ui/react';
import { getCachedConfig } from '../utils/configManager';
import { servicebookingFlowStore } from '../store/ServiceBookingFlowStore';
import { runInAction } from 'mobx';

const AppSkeleton = () => {
  
  const [config, setConfig] = useState<any>(null);

  useEffect(() => {
    // Get the cached config
    const cachedConfig = getCachedConfig();
    
    if (cachedConfig) {
      // Update the local state
      setConfig(cachedConfig);
      
      // Update the store with the configuration
      runInAction(() => {
        servicebookingFlowStore.configurationDetails = {
          ...servicebookingFlowStore.configurationDetails,
          ...cachedConfig
        };
      });
    }
  }, []);

  return (
    <main>
      <Box display="flex" flexDirection="column" minHeight="100vh">
            {config?.header_html && (
                <Box dangerouslySetInnerHTML={{ __html: config?.header_html }} />
            )}
      <Box display="flex" flexDirection={{ base: 'column', lg: 'row' }} width={{ base: '90%'}} gap="5" margin="auto" mt="5">
        <Box w={{ base: '100%' }}>

          <FormControl display="flex" justifyContent="center">
            <SimpleGrid columns={[1, 1, 2, 2, 4, 4]} gap={6} width="100%" boxShadow="md" p="6" rounded="md" borderWidth={1} mt={4}>
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton height="60px" key={index} />
              ))}
            </SimpleGrid>
          </FormControl>

          <SimpleGrid columns={[1]} spacing={4} mt={5} width={['100%']}>
            <Skeleton height="24px" width="200px" mb={4} />
            {Array.from({ length: 8 }).map((_, index) => (
              <Box key={index} display="flex" flexDirection="row" gap={4} p={4} borderWidth="1px" borderRadius="xl" boxShadow="md">
                <SkeletonCircle size="16" />
                <Box flex="1">
                  <Skeleton height="20px" width="70%" />
                  <SkeletonText mt="4" noOfLines={2} spacing="4" />
                  <Skeleton height="20px" width="50%" mt={2} />
                </Box>
              </Box>
            ))}
          </SimpleGrid>
        </Box>

      </Box>

      {config?.footer_html && (
                <Box mt={4} dangerouslySetInnerHTML={{ __html: config?.footer_html }} />
            )}
        </Box>
      
    </main>
  );
};

export default AppSkeleton;